export default {"src":"/_next/static/media/scroll.a805c122.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};